module.exports = __webpack_public_path__ + "b9c2481233dfa55d14cdf3a18d292794.jpg";